<template>
  <div class="basicLayout" :class="$flag ? 'mobile_layout' : 'pc_layout'">
    <template v-if="$route.path != '/index/index'">

      <el-container class="container" style="overflow-x:hidden;width:100%;box-sizing:border-box">
        <!-- 头部 -->
        <el-header v-if="!$route.query.user_id" class="clearfixed text-white"
          style="background: #fff;width:100%;position: fixed;z-index: 110;">
          <!--isLoginMune-->
          <div v-if="isLoginMune">
            <div class="logo m-r-80 pull-left cursor-pointer m-v-5">
              <img v-if="$flag" class="w-200" src="../assets/images/u11.png" alt style="width:320px;max-height:60px;"
                @click="$router.push('/index/index')" />
              <!--<img
                  v-else
                class="w-200"
                src="../assets/images/u11.png"
                alt
                style="width:320px;max-height:60px;"
                @click="$router.push('/index/index')"
              />-->

              <!-- <div
                style="display: inline-block;vertical-align: middle;color: #adadad;border-left: 2px solid #eee;padding-left: 16px;margin-left: 16px;"
              >
                <p style="font-weight:600;">验货在线服务平台</p>
                <p>Inspection Online Service Platform</p>
              </div>-->
            </div>
          </div>
          <div class="header head" v-else>
            <div class="flex a-center p-top" :class="$t('menu_top')" style="margin: 0 auto;">
              <div class="logo m-r-80 pull-left cursor-pointer">
                <img v-if="$flag" class="w-200" src="../assets/images/u12.png" alt style="width:127px;max-height:30px"
                  @click="$router.push('/index/index')" />
                <img v-else class="w-200" src="../assets/images/u11.png" alt style="width:320px;max-height:60px"
                  @click="$router.push('/index/index')" />
              </div>
              <div class="dashboard fs-14 pull-right" style="width:100%">
                <div class="pull-right flex a-center">
                  <!-- <el-dropdown style="margin-right:10px;vertical-align: super;height: 62px;" @command="handleCommand" trigger="click">
                    <span class="el-dropdown-link fs-14 cursor-pointer">
                      {{selCheck}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="zh">中文</el-dropdown-item>
                      <el-dropdown-item command="en">English</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>-->
                  <div style="margin-right:10px;vertical-align: super;height: 60px;">
                    <span class="cursor-pointer">
                      <img style="width:20px" :src="$tool.src(flag_url)" /> {{ selCheck }}</span><template
                      v-if="!$flag">|</template>
                    <span class="cursor-pointer" @mouseover="showLang = true">{{ $t('qx_lang_bnt') }}</span>
                  </div>

                  <div v-if="isLogin">
                    <el-dropdown size="medium">
                      <div>
                        <el-avatar style="vertical-align: middle;" :size="30" class="m-r-10">
                          <img :src="$tool.src(userInfo.head)" style="width:30px;" />
                          <!--  <img :src="$host.file+userInfo.head" style="width:30px;" /> -->
                        </el-avatar>
                        <span class="el-dropdown-link fs-14 cursor-pointer">{{ userInfo ? userInfo.nick : '' }}</span>
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="goInfoCenter()">{{ $t('layout_grzx') }}</el-dropdown-item>
                        <el-dropdown-item @click.native="logout()">{{ $t('layout_exit') }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <div v-else class="fs-14 relative"
                    style="line-height: 20px;height:30px;background: #fa7202;padding: 5px 15px;color: #fff;border-radius: 16px;">
                    <span class="cursor d-inline" @click="$router.push('/index/login')">{{ $t('layout_login') }}</span>
                    /
                    <el-popover visible-arrow="false" placement="bottom" width="240" class="d-inline-block"
                      trigger="click">
                      <div>
                        <!-- <el-tabs v-model="activeName" @tab-click="TabClick">
                            <el-tab-pane :label="$t('layout_user')" name="1"></el-tab-pane>
                            <el-tab-pane :label="$t('layout_yhgly')" name="2"></el-tab-pane>
                        </!-->
                        <div style="width:100%;text-align: center;margin-top:40px;">
                          <el-button type="primary" @click="$router.push('/index/register')">{{ $t('layout_ljzc')
                          }}</el-button>
                        </div>
                        <p style="text-align: center;margin:30px 0px;">
                          {{ $t('layout_hasZh') }}
                          <a @click="$router.push('/index/login')" class="cursor" style="color:#006cfd;">{{
                            $t('layout_login') }}</a>
                        </p>
                      </div>
                      <div slot="reference">
                        <span slot="reference" class="cursor d-inline">{{ $t('layout_zc') }}</span>
                      </div>
                    </el-popover>
                  </div>
                </div>
                <ul class="MuneList pull-right">
                  <template v-for="menu in menus">
                    <li :key="menu.name" :class="{ active: menu.name === currentPathName }" @click="handleClick(menu)"
                      v-if="!!!menu.hidden">
                      <!-- <router-link :to="menu.name">{{$t(menu.translate)}}</router-link> -->
                      <a :href="menu.path">{{ $t(menu.translate) }}</a>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </el-header>

        <div class="main" :style="'margin-top: ' + ($route.query.user_id ? 0 : 60) + 'px;'">
          <!-- <transition name="fade" mode="out-in"> -->
          <keep-alive>
            <router-view />
          </keep-alive>

          <!-- <router-view></router-view> -->
          <!-- </transition> -->
        </div>
        <!-- 尾部 -->
        <!-- <div class="footer" v-if="handleShow">
          <div class="footer_center">
            <ul>

              <li>
                <ul>
                  <li class="title">{{$t('about_qqyh_qyzz')}}</li>
                  <li>{{$t('about_qqyh_rtxmynydh')}}</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li class="title">{{$t('layout_myservice')}}</li>
                  <li><router-link to="/index/ourServer?index=0" tag="a" target="_blank">{{$t('page1item1')}}</router-link></li>
                  <li><router-link to="/index/ourServer?index=1" tag="a" target="_blank">{{$t('page1item2')}}</router-link></li>
                  <li><router-link to="/index/ourServer?index=2" tag="a" target="_blank">{{$t('page1item3')}}</router-link></li>
                  <li><router-link to="/index/ourServer?index=3" tag="a" target="_blank">{{$t('page1item4')}}</router-link></li>
                  <li><router-link to="/index/ourServer?index=4" tag="a" target="_blank">{{$t('page1item5')}}</router-link></li>
                  <li><router-link to="/index/ourServer?index=5" tag="a" target="_blank">{{$t('page1item6')}}</router-link></li>
                </ul>
              </li>
              <li>
                <ul>
                  <li class="title">{{$t('layout_gywm')}}</li>
                  <li>
                    <router-link to="/index/aboutUs" tag="a" target="_blank">{{$t('layout_gsjs')}}</router-link>
                  </li>
                  <li>
                    <router-link to="/index/aboutUs?tab=3" tag="a" target="_blank">{{$t('layout_jrwm')}}</router-link>
                  </li> -->
        <!-- <li>{{$t('layout_yjhjy')}}</li> -->
        <!-- </ul>
              </li>
              <li>
                <ul>
                  <li class="title">{{$t('layout_lxkf')}}</li>
                  <li>{{$t('layout_email')}}：{{KefuInfo.email}}</li>
                  <li>{{$t('layout_zhixun')}}：{{KefuInfo.mobile}}</li>
                  <li>{{$t('layout_hotline')}}：{{KefuInfo.phone}}</li>
                  <li>{{$t('layout_wxkf')}}：{{KefuInfo.wechat_photo}}</li>
                </ul>
              </li> -->
        <!--<li>
                <ul>
                  <li class="title">{{$t('layout_help')}}</li>
                  <li>{{$t('layout_ybxz')}}</li>
                  <li>{{$t('layout_czzy')}}</li>
                  <li>{{$t('layout_hqjf')}}</li>
                  <li>{{$t('layout_jfgz')}}</li>
                </ul>
              </li>-->
        <!-- </ul>
            <dl>
              <dd>
                <img :src="$host.file + Android_code" />
                <span>{{$t('azxz')}}</span>
              </dd>
              <dd>
                <img :src="$host.file + ios_code" />
                <span>{{$t('pgxz')}}</span>
              </dd>
              <dd>
                <img :src="$host.file + customer_code" />
                <span>{{$t('wxkf')}}</span>
              </dd>
            </dl>
          </div>
        </div> -->
      </el-container>

      <div class="chat-box-v" @click="openChat()">
        <div class="new-msg-box" :style="'display:' + (countMessage > 0 ? 'block' : 'none')" id="new_msg_count">{{
          countMessage }}</div>
        <img src="../assets/images/chat-v.png" alt />
      </div>
      <!--<div class="chat-box-v" @click="openChat()">
		  <div class="new-msg-box" id="new_msg_count"></div>
        <el-badge :value="countMessage" class="item" v-if="countMessage">
          <img src="../assets/images/chat-v.png" alt />

        </el-badge>
        <template v-else>
          <img src="../assets/images/chat-v.png" alt />

        </template>
      </div>-->


    </template>
    <template v-else>
      <div :class="$t('own_top_head')" class="container" id="init-header"
        style="position:fixed;left:0;top:0;right:0;z-index:1000;display:none;height:auto">
        <el-header class="clearfixed text-white fixed">
          <div v-if="isLoginMune">
            <div class="logo m-r-80 pull-left cursor-pointer m-v-5" style="line-height: 20px;color: rgb(173, 173, 173);
              width: 1200px;
              margin: 16px auto;
              position: relative;
              top: 0;
              left: 50%;
              margin-left: -600px;">
              <img v-if="$flag" class="w-200" src="../assets/images/u12.png" alt
                @click="$router.push('/index/index')" />
              <img v-else class="w-200" src="../assets/images/u11.png" alt @click="$router.push('/index/index')" />
              <!--<div
                style="display: inline-block;vertical-align: middle;color: #adadad;border-left: 2px solid #eee;padding-left: 16px;margin-left: 16px;"
              >
                <p style="font-weight:600;">验货在线服务平台</p>
                <p>Inspection Online Service Platform</p>
              </div>-->
            </div>
          </div>
          <div class="header head" v-else>
            <div class="flex a-center p-top" :class="$t('menu_top')" style="margin: 0 auto;">
              <div class="logo m-r-80 pull-left cursor-pointer">
                <img v-if="$flag" src="../assets/images/u12.png" alt style="width:127px;height:30px"
                  @click="$router.push('/index/index')" />
                <img v-else src="../assets/images/u11.png" alt style="width:320px;max-height:60px"
                  @click="$router.push('/index/index')" />
              </div>
              <div class="dashboard fs-14 pull-right" style="width:100%">
                <div class="pull-right flex a-center">
                  <!-- <el-dropdown style="margin-right:10px;vertical-align: super;height: 62px;" @command="handleCommand" trigger="click">
                    <span class="el-dropdown-link fs-14 cursor-pointer">
                      {{selCheck}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="zh">中文</el-dropdown-item>
                      <el-dropdown-item command="en">English</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>-->
                  <div style="margin-right:10px;vertical-align: super;height: 60px;">

                    <template v-if="$flag">
                      <!--语言切换-->

                      <img @click="showmLang = true" style="width:20px" :src="$tool.src(flag_url)" />
                      <span @click="showmLang = true" class="cursor-pointer">
                        {{ selCheck }}</span>



                      <!--mobile展开菜单-->
                      <div class="wap-box" @click="show_nav = true">
                        <van-icon style="vertical-align:middle; " name="wap-nav" size="35" />
                      </div>



                    </template>
                    <template v-else>
                      <img style="width:20px" :src="$tool.src(flag_url)" />
                      <span class="cursor-pointer">
                        {{ selCheck }}</span>|
                    </template>

                    <!--<span class="cursor-pointer" @click="handleCommand('zh')">{{$t('Chinese')}}</span> |
                    <span class="cursor-pointer" @click="handleCommand('en')">English</span>-->
                    <span class="cursor-pointer" @mouseover="showLang = true">{{ $t('qx_lang_bnt') }}</span>
                  </div>

                  <div v-if="isLogin">
                    <el-dropdown v-if="!$flag" size="medium">
                      <div>
                        <el-avatar style="vertical-align: middle;" :size="30" class="m-r-10">
                          <img :src="$tool.src(userInfo.head)" style="width:30px;" />
                        </el-avatar>
                        <span class="el-dropdown-link fs-14 cursor-pointer">{{ userInfo ? userInfo.nick : '' }}</span>
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="goInfoCenter()">{{ $t('layout_grzx') }}</el-dropdown-item>
                        <el-dropdown-item @click.native="logout()">{{ $t('layout_exit') }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <div v-else class="fs-14 relative" style="line-height: 20px;height:30px;background: #fa7202;padding: 5px 15px;
                    color: #fff;
                    border-radius: 16px;">
                    <span class="cursor d-inline" @click="$router.push('/index/login')">{{ $t('layout_login') }}</span>
                    /
                    <el-popover visible-arrow="false" placement="bottom" width="240" class="d-inline-block"
                      trigger="click">
                      <div>
                        <!-- <el-tabs v-model="activeName" @tab-click="TabClick">
                            <el-tab-pane :label="$t('layout_user')" name="1"></el-tab-pane>
                            <el-tab-pane :label="$t('layout_yhgly')" name="2"></el-tab-pane>
                        </!-->
                        <div style="width:100%;text-align: center;margin-top:40px;">
                          <el-button type="primary" @click="$router.push('/index/register')">{{ $t('layout_ljzc')
                          }}</el-button>
                        </div>
                        <p style="text-align: center;margin:30px 0px;">
                          {{ $t('layout_hasZh') }}
                          <a @click="$router.push('/index/login')" class="cursor" style="color:#006cfd;">{{
                            $t('layout_login') }}</a>
                        </p>
                      </div>
                      <div slot="reference">
                        <span slot="reference" class="cursor d-inline">{{ $t('layout_zc') }}</span>
                      </div>
                    </el-popover>
                  </div>
                </div>
                <ul class="MuneList pull-right">
                  <template v-for="menu in menus">
                    <li :key="menu.name" :class="{ active: menu.name === currentPathName }" @click="handleClick(menu)"
                      v-if="!!!menu.hidden">
                      <!-- <router-link :to="menu.name">{{$t(menu.translate)}}</router-link> -->
                      <a :href="menu.path">{{ $t(menu.translate) }}</a>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </el-header>
      </div>
      <div class="main" style="margin-top: 60px;">
        <router-view />
      </div>
    </template>
    <!-- <Im></Im> -->

    <el-dialog :title="$t('qx_lang')" :visible.sync="showLang" width="40%">
      <div>
        <el-row>
          <el-col style="margin-bottom:8px" v-for="(item, index) in lang_list" :key="index" :span="6">
            <span @click="setLang(item)" class="lang-bnt">
              <img :src="$tool.src(item.flag)" />
              {{ item.name }}</span>
          </el-col>
        </el-row>
      </div>

    </el-dialog>
    <van-action-sheet v-model="showmLang" :cancel-text="$t('pay_qx')" close-on-click-action @cancel="showmLang = false">
      <div class="clang-big-box">
        <div v-for="(item, index) in lang_list" :key="index" @click="setLang(item)" class="mlang"
          :class="$i18n.locale == item.type ? 'mseleced' : ''">
          <img style="width:20px" :src="$tool.src(item.flag)"> {{ item.name }}
        </div>
      </div>
    </van-action-sheet>
    <van-popup v-model="show_nav" position="right" :style="{ height: '100%', background: 'rgba(255, 80, 35, .8)' }">
      <div class="header_menu ">
        <ul id="menu">
          <li @click="show_nav = false"><router-link to="/">{{ $t('user_WEb_SY') }} </router-link></li>
          <template v-if="isLogin">
            <li><router-link to="/user/index">{{ $t('layout_grzx') }}</router-link></li>
            <li @click="logout(); show_nav = false"> {{ $t('layout_exit') }} </li>
          </template>
          <template v-else>
            <li @click="show_nav = false"><router-link to="/index/login">{{ $t('layout_login') }}</router-link></li>
            <li @click="show_nav = false"><router-link to="/index/register">{{ $t('layout_ljzc') }} </router-link></li>
          </template>
        </ul>

        <div class="rcode-box">
          <div class="ewmtbox">
            <a href="http://www.inspector.ltd/api/u_is/androidDownload">
              <img style="width:180px" :src="$host.file + Android_code" />
            </a>
          </div>
          <div class="menu-app-tp">Android</div>

          <div class="ewmtbox">
            <a href="https://apps.apple.com/app/id1524403672">
              <img style="width:180px" :src="$host.file + ios_code" /></a>
          </div>
          <div class="menu-app-tp">IOS</div>
        </div>
      </div>
    </van-popup>


    <!-- <visitorchat v-if="onlineChat" :showModal="false" :drag="true"></visitorchat> -->
    <el-dialog title="在线聊天" :visible.sync="onlineChat" v-if="onlineChat" width="1000px" top="5vh" class="chat-dialog"
      :close-on-click-modal="false" v-el-drag-dialog>
      <template v-if="is_visit">
        <visitorchatInline :showModal="false"></visitorchatInline>
      </template>
      <iframe v-else :src="chatUrl" width="100%" height="100%" frameborder="0" scrolling="auto"></iframe>
    </el-dialog>
  </div>
</template>

<script>
//addressSearchFromGaode
import SideMenu from "@/components/SideMenu.vue";
// import Im from "@/components/Im.vue";
import visitorchatInline from "@/components/visitorchatInline.vue";
import { mapState } from "vuex";
import router from "@/router/webRouter.js";
import { queryTest, logout, switch_set } from "@/api/user";
import { getCustomer } from "@/api/webKefu";
import { unreadMessage, messageCount } from "@/api/chat";
import cookie from "js-cookie";
export default {
  name: "basicLayout",
  inject: ["reload"],
  components: {
    SideMenu,
    visitorchatInline
    // Im
  },
  computed: {
    ...mapState("global", ["countries", "userInfo"]),
    // kefuImg() {
    //   let arr = this.KefuInfo.customer_code ? this.KefuInfo.customer_code : [];
    //   return arr;
    // },

    menus() {
      const { children } = router;

      let route = children.map(
        ({ path, name, label, hidden = false, translate }) => ({
          path,
          name,
          label: label ? label : name,
          hidden,
          translate
        })
      );
      let token = localStorage.getItem("USERToken");
      let goPath = "/user";

      // 没有登录的情况下点击订单就就先登录
      let obj = {
        name: "/index/login",
        path: "/index/login",
        label: this.$t("layout_wddd"),
        translate: "layout_wddd"
      };

      if (token) {
        // let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        // 存在token 登录下，判断用户是质检员还是客户的
        this.userInfo.role == 1 ? (goPath = "/user") : this.userInfo.role == 2 ? (goPath = "/insp") : (goPath = "/user");

        obj = {
          name: goPath + "/" + "orderManage",
          path: goPath + "/" + "orderManage",
          label: this.$t("layout_wddd"),
          translate: "layout_wddd"
        };
      }

      route.splice(1, 1, obj);
      // if(userInfo.role == 1){
      //   route.splice(4,1)
      // }
      //预渲染需匹配全路由
      route.forEach(item => {
        if (item.path.indexOf('/') < 0) {
          item.path = "/index/" + item.path;
          item.name = "/index/" + item.name;
        }
      });
      // console.log(route);
      return route;
    }
  },
  //  mounted(){
  //  console.log(' ', this.$store)
  //  },
  watch: {
    $route(to, from) {
      if (to.path == "/index/index") {
        //console.log('to.path ',to.path )

        this.handleShow = true;
      } else {
        this.handleShow = true;
      }
      if (to.path == "/index/login") {
        this.currentPathName = to.path;
        if (this.$flag) {
          this.isLoginMune = true;
        } else {
          this.isLoginMune = false;
        }

      } else {
        this.isLoginMune = false;
      }
    }
  },
  data() {
    return {
      timer2: '',
      countMessage: 0,
      selCheck: "中文",
      flag_url: "/static/flag/CN.png",
      isLogin: false,
      currentPathName: "",
      activeName: "1",
      navList: [
        {
          label: this.$t("layout_wsuser"),
          num: 0
        },
        {
          label: this.$t("layout_wsyhy"),
          num: 0
        }
      ],
      // userInfo:'',
      handleShow: true,
      isLoginMune: true,
      KefuInfo: {},
      handlelog: true,
      Android_code: "",
      ios_code: "",
      customer_code: "",
      lang_list: [{
        type: 'zh-cn',
        name: "中文",
        flag: "/static/flag/CN.png"
      }, {
        type: 'zh-tw',
        name: "中文(繁體)",
        flag: "/static/flag/CN.png"
      },
      {
        type: 'en-us',
        name: "English",
        flag: "/static/flag/US.png"
      }, {
        type: 'ko-re',
        name: "한국어",
        flag: "/static/flag/KR.png"
      }, {
        type: 'in-do',
        name: "Indonesia",
        flag: "/static/flag/ID.png"
      }, {
        type: 'ja-jp',
        name: "日文",
        flag: "/static/flag/JP.png"
      }, {
        type: 'ru-ru',
        name: "Русский язык",
        flag: "/static/flag/RU.png"
      }, {
        type: 'pt-pt',
        name: "Português",
        flag: "/static/flag/PT.png"
      }, {
        type: 'es-la',
        name: "Español",
        flag: "/static/flag/ES.png"
      }, {
        type: 'it-it',
        name: "Italiano",
        flag: "/static/flag/IT.png"
      }, {
        type: 'fr-fr',
        name: "Français",
        flag: "/static/flag/FR.png"
      }, {
        type: 'de-de',
        name: "Deutsch",
        flag: "/static/flag/DE.png"
      }, {
        type: 'ar-ab',
        name: "بالعربية",
        flag: "/static/flag/AE.png"
      }],
      showLang: false,
      showmLang: false,
      show_nav: false,
      onlineChat: false,
      chatUrl: '',
      is_visit: 1
    };
  },
  created() {
    // 记录渠道id
    if (this.$route.query.channel) {
      sessionStorage.setItem('source_channel', this.$route.query.channel)
    }
    this.$store.dispatch("global/fetchCountries").then(() => {
      // console.log(this.countries)
    });
    this.isLogin = localStorage.getItem("USERToken") ? true : false;
    // this.selCheck = localStorage.getItem("selCheck") || "中文";
    var locale = localStorage.getItem('locale');
    this.flag_url = "/static/flag/CN.png";
    for (var i in this.lang_list) {
      if (this.lang_list[i].type == locale) {
        this.flag_url = this.lang_list[i].flag;
        this.selCheck = this.lang_list[i].name;
        break;
      }
    }
    //localStorage.setItem("flag_url", this.flag_url);
    this.init();
    let path = this.$route.path;
    console.log(path)
    if (path == "/index/index") {
      this.handleShow = false;
    } else {
      this.handleShow = true;
    }
    // 判断是否是登录界面
    if (path == "/index/login") {
      this.isLoginMune = false;
    } else {
      this.isLoginMune = false;
    }
    this.getCustomer();

  },
  methods: {
    async unreadMessage() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let res = {};
      if (userInfo) {
        res = await unreadMessage();
      } else {
        res = await messageCount();
      }
      const { code, data, msg } = res.data;
      this.handlelog = true
      if (code == 200) {
        localStorage.setItem('admin_ids', data.admin_id) //该客户是否分配了跟单员  0 - 未分配
        if (data.count && this.countMessage != data.count) {
          this.countMessage = data.count ? data.count : "";
        }
      }
    },
    openChat() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : "";
      let newObj = {};

      if (this.$router.currentRoute.path.indexOf('/index/wantOrder') > -1 || this.$router.currentRoute.path.indexOf('/index/visitOrder') > -1) {
        // 以iframe方式打开聊天界面
        if (userInfo) {
          this.is_visit = 0

          var im_token = localStorage.getItem('im_token'),
            chatUrl = "/hchat/?t=1744162614#/message?im_user_id=" + im_token;
          if (this.$route.query.im_id) {//需要监听的参数
            chatUrl = "/hchat/?t=1744162614#/message?conversation_id=" + this.$route.query.im_id + "&im_user_id=" + im_token;
            return;
          }
          this.chatUrl = this.$tool.chat(chatUrl)
          // this.chatUrl = 'http://127.0.0.1:8004/?t=1744162614#/message?im_user_id=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJcdTU3MjhcdTdlYmZcdTlhOGNcdThkMjciLCJhdWQiOiJwZW9wbGUiLCJleHAiOjE3NTk2Mjg2NjAsImlhdCI6MTc1NzAzNjY2MCwibmJmIjoxNzU3MDM2NjYwLCJkYXRhIjp7InJvbGUiOiIyIiwidWlkIjo1NTMyNSwicHdkIjoiZTEwYWRjMzk0OWJhNTlhYmJlNTZlMDU3ZjIwZjg4M2UifX0.SVP5OxJdOm4YfbjqVO3n9V-4zZwVZQJb_b0acexnsEsm_hbqJyWTcAmk47WJUDoyNA1zoB8jZxyywxcvo-dwxk4H3xg4dPRTP_enFLY0jeG1Ful5Xi32Ycrzy-zRTfbBv7i7ZCETB6U0QzoemSCBuiyE2lJiOu5YIfjWAL0yYw8';
          console.log('this.chatUrl', this.chatUrl);

        } else {
          this.is_visit = 1
          // this.chatUrl = "/visitorchat"

        }
        this.onlineChat = true
        return false
      }
      if (userInfo) {
        newObj = this.$router.resolve({ path: "/groupchat" });
      } else {
        newObj = this.$router.resolve({ path: "/visitorchat" });
      }
      window.open(newObj.href, "_blank");
    },
    //获取客服信息
    async getCustomer() {
      const res = await getCustomer();
      const { code, data } = res.data;
      if (code == 200) {
        this.KefuInfo = data;
        this.Android_code = data.Android_code;
        this.ios_code = data.ios_code;
        this.customer_code = data.customer_code[0]
        localStorage.setItem("KefuInfo", JSON.stringify(data));
      }
    },
    //选择用户角色
    TabClick(val) {
      //角色 1-用户 2-验货员
      localStorage.setItem("role", val.name);
    },
    // 跳转到个人中心
    goInfoCenter() {
      let role = this.userInfo.role;
      let url = "";
      role == 2 ? (url = "/insp/index") : (url = "/user/index");
      url = "/user/index";
      this.$router.push(url);
    },

    setLang(item) {
      this.selCheck = item.name;
      this.flag_url = item.flag;
      cookie.set('think_var', item.type, { expires: 30, path: '/' })
      localStorage.setItem("locale", item.type);
      this.$i18n.locale = item.type;
      window.location.reload();
    },
    handleCommand(e) {
      // this.selCheck = e == "zh" ? "中文" : "English";
      // localStorage.setItem("selCheck", this.selCheck);
      localStorage.setItem("locale", e);
      this.$i18n.locale = e;
      window.location.reload();
      // console.log(this.$i18n.locale)
    },
    init() {
      const { name } = this.$route;
      this.currentPathName = name.indexOf('/') < 0 ? "/index/" + name : name;
    },
    handleClick({ name }) {
      this.currentPathName = name;
      //  处理下点击我的订单后的跳转问题
      // console.log("处理点击"+name);
      this.reload();
    },
    async logout() {
      const res = await logout();
      if (res.data.code == 200) {
        //mydev
        cookie.remove("auto_token");
        cookie.remove("user_id");
        this.$message.success(this.$t("layout_exitSuccess"));
        this.isLogin = false;
        // this.$router.push("/index/index");

        localStorage.removeItem("USERToken");
        localStorage.removeItem("userInfo");
        this.$store.commit("global/set_userInfo", "");
        // localStorage.setItem("locale",'zh');
        localStorage.removeItem("selCheck");
        localStorage.removeItem("im_token");
        localStorage.removeItem("role");
        localStorage.removeItem("shareCode");
        window.location.href = "/index/index"
      }
    }
  },
  mounted() {
    //   window.addEventListener('scroll',function(){

    //  console.log(' ',document.documentElement.scrollTop||document.body.scrollTop )
    //  },false)
    let that = this;
    this.unreadMessage();
    return;
    this.timer2 = setInterval(() => {
      if (that.handlelog) { //判断是否已经完成
        that.handlelog = false
        that.unreadMessage();
      }
    }, 10000);
  },
  destroyed() {
    return;
    // 清空定时器
    clearInterval(this.timer);
    this.timer = null
  }
};
</script>

<style lang="scss" scoped>
/* 小屏幕的样式*/
@media screen and (max-width: 720px) {

  .pull-left,
  .m-v-5,
  .logo {
    line-height: 20px;
    color: rgb(173, 173, 173);
    position: relative;
    top: 0;
  }
}

/* 大屏幕的样式*/
@media screen and (min-width: 721px) {

  .pull-left,
  .m-v-5,
  .logo {
    line-height: 20px;
    color: rgb(173, 173, 173);
    position: relative;
    top: 0;
    left: 50%;
    margin: 0px auto;
    margin-left: -600px;
  }

  .ru_ru_menu_top .logo {
    left: 45% !important;
  }
}

ul,
li,
ol {
  list-style-type: none;
}

$header-height-important: 60px !important;

.basicLayout {
  width: 100%;
  height: 100%;
}

.fixed {
  position: fixed;
  z-index: 99999;
}

.container {
  height: 100%;
  display: block;

  .header {
    // background-color: $--color-primary;
    // height: $header-height-important;
    // line-height: $header-height-important;
    // border-bottom: 1px solid $--color-primary;
    width: 100%;
    height: 60px !important;
    line-height: 56px !important;
    border-bottom: 1px solid #eee;
    color: #333;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 333;
    background: #fff;

    .p-top {
      width: 1200px;
    }

    .de_de_menu_top,
    .it_it_menu_top,
    .es_la_menu_top,
    .pt_pt_menu_top,
    .fr_fr_menu_top,
    .ru_ru_menu_top {
      width: 75% !important;
    }
  }

  .aside {
    background-color: #d6d7d8;
  }

  .main {
    .content {
      flex: 1;
    }
  }
}

.head {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.MuneList {
  li {
    display: inline-block;
    margin-right: 30px;

    a {
      display: inline-block;
    }
  }
}

.active {
  color: $--color-primary;
  border-bottom: 4px solid #fa7202;
}

.cursor {
  cursor: pointer;
}

.footer {
  // background: #e4e4e4;
  background: red;
  display: block;
  height: auto;

  .footer_center {
    display: flex;
    align-items: top;
    width: 1200px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin: 0 auto;

    &>ul {
      display: flex;
      align-items: top;
      width: 750px;
      height: auto;

      &>li {
        min-width: 20%;
        display: inline-block;
        vertical-align: top;
        text-align: left;
      }

      li {
        margin: 8px 20px 5px 0px;
        font-size: 14px;

        &.title {
          font-size: 16px;
          margin-bottom: 10px;
          padding-left: 6px;
          border-left: 4px solid #fa7202;
        }
      }

      li:not(:first-child) {
        margin: 8px 20px 5px 10px;
      }
    }

    &>dl {
      display: flex;
      justify-content: space-between;
      width: 450px;

      dd {
        width: 28%;
        margin: 10px 2% 0 2%;

        img {
          width: 100%;
        }

        span {
          color: #999;
          font-size: 12px;
          text-align: center;
          line-height: 30px;
          display: block;
        }
      }
    }
  }

  .footer_bot {
    padding: 20px;
    background: #c9c9c9;
    color: #333;

    .footer_center_bt {
      margin: 0 auto;
      text-align: center;
      font-size: 12px;

      li {
        display: inline-block;

        img {
          margin-right: 20px;
          width: 80px;
          height: 30px;
        }
      }

      p {
        margin: 10px 0;
      }
    }
  }
}

.head-top {
  background: #eee;

  .head-top-left {
    float: left;
    line-height: 30px;
  }
}

/deep/ .el-dropdown {
  vertical-align: super;
  height: 62px;
}

/deep/ .tablist {
  padding: 10px;
}

/deep/ #tab-1 {
  width: 90px;
  text-align: center;
}

/deep/ .el-popper {
  background: #f5f5f5 !important;
}

/deep/ .el-tabs__active-bar {
  width: 70px !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 720px) {
  .logo {
    margin-right: 0px;
    overflow: hidden;
  }

  .container {
    .header {
      .p-top {
        width: 100%;
      }
    }

    .MuneList {
      display: none;
    }
  }

}

.new-msg-box {
  position: absolute;
  background: #f00;
  color: #fff;
  width: 20px;
  height: 20px;
  line-height: 18px;
  border-radius: 10px;
  text-align: center;
  font-size: 10px;
  left: 10px;
  top: -15px;
  display: none;
  border: 2px solid #fff;
}

.lang-bnt {

  cursor: pointer;
}

.clang-big-box {
  padding-bottom: 20px;
  margin-top: 20px;
  max-height: 500px;
  overflow-y: scroll;
}

.mlang {
  padding: 10px 0;
  text-align: center;
}

.mseleced {
  color: #ee0a24;
}

.wap-box {
  display: inline-block;
  vertical-align: middle;
}

.header_menu {
  width: 200px;
  color: #fff;
  text-align: center;
}

/deep/ .chat-dialog .el-dialog {
  height: 90vh;
  max-height: 700px;
}

/deep/ .chat-dialog .el-dialog__body {
  padding: 0;
  height: 100%;
}
</style>